import cn from 'classnames'

type IndicatorDotProp = {
  active: boolean
  index: number
  onClick?: (index: number) => void
  className?: string
}

const IndicatorDot = (props: IndicatorDotProp) => {
  const { active, onClick, index, className } = props

  const handleClick = () => {
    if (active) return // do nothing if already active
    typeof onClick === 'function' && onClick(index)
  }

  return (
    <button className="cursor-pointer px-1" onClick={handleClick} type="button">
      <div
        className={cn(
          'h-[12px] rounded-full outline outline-1 outline-[#00D973] transition-all',
          !active && 'w-[12px] bg-[#A8FF8F]/30',
          active && 'w-[50px] bg-[#00D973]',
          className,
        )}
      />
    </button>
  )
}

export default IndicatorDot
